export default function SuitableCompanies() {
  const industries = [
    { icon: 'ri-building-2-line', label: 'B2B' },
    { icon: 'ri-shopping-bag-3-line', label: 'B2C' },
    { icon: 'ri-tools-line', label: 'Производство' },
    { icon: 'ri-service-line', label: 'Услуги' },
    { icon: 'ri-code-s-slash-line', label: 'IT' },
    { icon: 'ri-ship-line', label: 'Логистика' },
    { icon: 'ri-home-4-line', label: 'Недвижимость' },
    { icon: 'ri-building-4-line', label: 'Строительство' },
    { icon: 'ri-truck-line', label: 'Дистрибуция' },
    { icon: 'ri-bank-line', label: 'Финансы' },
    { icon: 'ri-heart-pulse-line', label: 'Медицинские компании' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Для каких компаний подходит
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Телефонные продажи универсальны. Наш опыт охватывает десятки отраслей — от производства до финансового сектора.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4 max-w-4xl mx-auto">
          {industries.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-4 text-center hover:bg-teal-50 transition-colors group cursor-default">
              <div className="w-10 h-10 bg-teal-600/10 rounded-lg flex items-center justify-center flex-shrink-0 mx-auto mb-3 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-lg`}></i>
              </div>
              <span className="text-sm font-medium text-gray-700 group-hover:text-teal-700 transition-colors">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}